import React from "react";
import { NextSeo } from "next-seo";
import { useRouter } from "next/router";

const DEFAULT_TITLE = "Matic";
const DEFAULT_DESCRIPTION =
  "The world's most advanced floor cleaner. Your home's best helper.";
const DEFAULT_OG_IMAGE = {
  type: "image/png",
  width: 1200,
  height: 630,
  url: "https://images.ctfassets.net/6p328xbjc78k/7E3isvhfT5EiANxi4k7Mtf/ec0a6564a8571d5be19c24ed8f57b376/webcard-1200x630.jpg",
};
const DEFAULT_TWITTER_IMAGE = {
  type: "image/png",
  width: 627,
  height: 627,
  url: "https://images.ctfassets.net/6p328xbjc78k/3xeF4vFmF85o9kww5tWN3D/ff7268e63f204ff8dae78f433634df6d/webcard-627x627.png",
};
const SITE_NAME = "Matic Robots";

function removeTrailingSlash(str) {
  return str.endsWith("/") ? str.slice(0, -1) : str;
}

export default function (props) {
  const router = useRouter();
  const pageKey = props.page || "_default";
  const config = props.config || {};
  const pageConfig = config[pageKey] || {};

  pageConfig.title = props.overrideTitle || pageConfig.title || DEFAULT_TITLE;
  pageConfig.description = pageConfig.description || DEFAULT_DESCRIPTION;
  pageConfig.canonical = removeTrailingSlash(
    pageConfig.canonical ||
      `https://${process.env.NEXT_PUBLIC_WEB_DOMAIN}${router.asPath}`
  );
  pageConfig.openGraph = pageConfig.openGraph || {};
  pageConfig.twitter = pageConfig.twitter || {};

    if(props.page == "404" || props.page == "orderConfirm"){
      pageConfig.noindex = true
      pageConfig.nofollow = true
    }

  /* Open Graph */
  pageConfig.openGraph.url =
    pageConfig.canonical ||
    `${process.env.NEXT_PUBLIC_WEB_DOMAIN}${router.asPath}`;
  pageConfig.openGraph.site_name = pageConfig.openGraph.site_name || SITE_NAME;
  pageConfig.openGraph.title =
    pageConfig.openGraph.title || pageConfig.title || DEFAULT_TITLE;
  pageConfig.openGraph.description =
    pageConfig.openGraph.description ||
    pageConfig.description ||
    DEFAULT_DESCRIPTION;
  pageConfig.openGraph.images = pageConfig.openGraph.images || [
    DEFAULT_OG_IMAGE,
    DEFAULT_TWITTER_IMAGE,
  ];

  /* Twitter */
  pageConfig.twitter.title =
    pageConfig.twitter.title || pageConfig.title || DEFAULT_TITLE;
  pageConfig.twitter.description =
    pageConfig.twitter.description ||
    pageConfig.description ||
    DEFAULT_DESCRIPTION;
  pageConfig.twitter.cardType =
    pageConfig.twitter.cardType || "summary_large_image";

  return <NextSeo {...pageConfig} />;
}
